(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["generic-no-heading"]) return;
  try {
    


    let images = document.querySelectorAll('.generic .media-gallery img'); 
    let featured = images[0];

    let check = 0;
    images.forEach( image => {
         if( check == 0 ) {
            check = 1;
         } else {
            image.addEventListener( 'click', function() {
                let aux = image.src;
                image.src = featured.src; 
                featured.src = aux ; 
            });
         }
    });


    let imgs = document.querySelectorAll("img");
    imgs.forEach( img => {
        if( img.parentElement.tagName === "P" ) {
            img.parentElement.style.margin = "2rem 0";
            img.parentElement.style.width = "100%";
            img.style.height = "auto";
            img.style.width = "100%";
        }
    });

    let iframes = document.querySelectorAll("iframe");
    iframes.forEach( iframe => {
        if( iframe.parentElement.tagName === "P") {
            iframe.parentElement.style.margin = "2rem 0";
            iframe.parentElement.style.width = "100%";
        }
    }); 


    let contentForLayout = document.querySelector(".content-for-layout");
    let generic = document.querySelector(".generic");

    if ( generic ) {
        contentForLayout.classList.add("generic-page-grid");
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["generic-page"]) return;
  try {
    


    let images = document.querySelectorAll('.generic .media-gallery img'); 
    let featured = images[0];

    let check = 0;
    images.forEach( image => {
         if( check == 0 ) {
            check = 1;
         } else {
            image.addEventListener( 'click', function() {
                let aux = image.src;
                image.src = featured.src; 
                featured.src = aux ; 
            });
         }
    });


    let imgs = document.querySelectorAll("img");
    imgs.forEach( img => {
        if( img.parentElement.tagName === "P" ) {
            img.parentElement.style.margin = "2rem 0";
            img.parentElement.style.width = "100%";
            img.style.height = "auto";
            img.style.width = "100%";
        }
    });

    let iframes = document.querySelectorAll("iframe");
    iframes.forEach( iframe => {
        if( iframe.parentElement.tagName === "P") {
            iframe.parentElement.style.margin = "2rem 0";
            iframe.parentElement.style.width = "100%";
        }
    }); 


    let contentForLayout = document.querySelector(".content-for-layout");
    let generic = document.querySelector(".generic");

    if ( generic ) {
        contentForLayout.classList.add("generic-page-grid");
    }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
  super();
}

connectedCallback() {
  this.header = document.getElementById('shopify-section-header');
  this.headerBounds = {};
  this.currentScrollTop = 0;
  this.preventReveal = false;
  this.predictiveSearch = this.querySelector('predictive-search');

  this.onScrollHandler = this.onScroll.bind(this);
  this.hideHeaderOnScrollUp = () => this.preventReveal = true;

  this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.addEventListener('scroll', this.onScrollHandler, false);

  this.createObserver();
}

disconnectedCallback() {
  this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
  window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
  let observer = new IntersectionObserver((entries, observer) => {
    this.headerBounds = entries[0].intersectionRect;
    observer.disconnect();
  });

  observer.observe(this.header);
}

onScroll() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

  if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      let swiperOptions = {
        slidesPerView: 1.1,
        spaceBetween: 16,
        scrollbar: {
          el: '.recommendationsSlider .swiper-scrollbar',
          draggable: true,
        },
        navigation: {
          nextEl: '.recommendationsSlider .swiper-button-next',
          prevEl: '.recommendationsSlider .swiper-button-prev',
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 451px
          451: {
            slidesPerView: 2.2
          },
          // when window width is >= 551px
          551: {
            slidesPerView: 2.7
          },
          // when window width is >= 751px
          751: {
            slidesPerView: 3.2
          },
          // when window width is >= 991px
          991: {
            slidesPerView: 3.7
          },
          // when window width is >= 1251px
          1251: {
            slidesPerView: 4.2
          },
          // when window width is >= 1441px
          1441: {
            slidesPerView: 4.7
          },
        }
      };

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              const bannerSlider = new Swiper('.recommendationsSlider', swiperOptions);

            }

            if (html.querySelector('.swiper-slide')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
